export const showIframe = (url: string) => {
	// Set iframe source first
	const iframe = document.getElementById('iframe') as HTMLIFrameElement | null
	if (iframe) {
		iframe.setAttribute('src', url)
	}

	// Fade in overlay after 200ms (like jQuery fadeIn)
	setTimeout(() => {
		const overlay = document.getElementById('overlay')
		if (overlay) {
			overlay.style.display = 'flex'
			overlay.style.transition = 'opacity 100ms ease-in-out'
			overlay.style.opacity = '0'
			// Trigger fade in
			requestAnimationFrame(() => {
				overlay.style.opacity = '1'
			})
		}
		// Disable scrolling
		document.body.style.overflow = 'hidden'
	}, 200)
}
